/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  profile: 'Profil',
  settings: 'Einstellungen',
  name: 'Name',
  email: 'E-Mail',
  password: 'Passwort',
  passwordConfirmation: 'Passwort Bestätigung',
  locale: 'Sprachumgebung',
  view: 'Ansicht',
  comfortable: 'Komfortable',
  compact: 'Kompakt',
  line: 'Zeile',
  full: 'Voller',
  narrow: 'Eng',
  sort: 'Sortierung',
  lastModifiedFirst: 'Zuletzt modifiziert zuerst',
  lastCreatedFirst: 'Zuletzt erstelltes zuerst',
  alphabetically: 'Alphabetisch',
  theme: 'Theme',
  dark: 'Dunkles',
  light: 'Helles',
  save: 'speichern',
  saveSuccess: 'Profil erfolgreich gespeichert.',
  saveFailure: 'Profil konnte nicht gespeichert werden.',
  fetchFailure: 'Profil konnte nicht abgerufen werden.',
  application: 'Applikation',
  install: 'installieren',
  youCanInstallPlainpad: 'Sie können Plainpad installieren und direkt vom Host-Rechner aus darauf zugreifen.',
  invalidateCache: 'Cache invalidieren',
  encrypt: 'Verschlüsseln',
  yes: 'Ja',
  no: 'Nein',
  passwordsMismatch: 'Die angegebenen Passwörter stimmen nicht überein, bitte versuchen Sie es erneut.',
  invalidateCachePrompt: 'Sind Sie sicher, dass Sie den lokalen Cache invalidieren wollen? Nicht synchronisierte Informationen werden verloren gehen.'
}
